import React, { useState, useEffect, useRef } from 'react';
import Button from '@mui/material/Button';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import AddCircle from '@mui/icons-material/AddCircle';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import CircularProgress from '@mui/material/CircularProgress';
import { DateTime } from 'luxon';

import { createSearchParams, useSearchParams, useNavigate } from 'react-router-dom';
import { objectToQueryString, baseUrl, apiHelper } from 'helpers/util';
import { notify } from 'helpers/globalFunctions';

import ColumnBox from 'components/ColumnBox';
import SmallHeading from 'components/SmallHeading';

export default function Form(props) {
    const entryType = props.entryType;
    const warehouse = props.warehouse;

    const navigate = useNavigate();
    const [ searchParams, setSearchParams ] = useSearchParams();
    const [ storeEntryId, setStoreEntryId ] = useState(null);
    const [ menuDate, setmenuDate ] = useState(DateTime.now());


    const [ productOptions, setProductOptions ] = useState([]);
    const [ productHash, setProductHash ] = useState({});
    const [ storeProduct, setStoreProduct ] = useState(null);

    const [ menuTypeOptions, setMenuTypeOptions ] = useState([]);
    const [ menuType, setMenuType ] = useState(null);
    const formErrorState = useRef({})

    const [ menuDetails, setMenuDetails ] = useState('');
    const [ isFormSubmitting, setIsFormSubmitting ] = useState(false);

    const onClickSave = function() {
        console.log(formErrorState.current);
        for (const f in formErrorState.current) {
            if (formErrorState.current[f]) {
                notify.error({ description: 'Please fill all details' });
                return;
            }
        }
        let menuDateStr = menuDate;
        if (menuDate && menuDate.toFormat) {
            menuDateStr = menuDate.toFormat('yyyy-MM-dd');
        }
        const payload = { 'menu_date': menuDateStr,
            'menu_type': menuType,
            warehouse, 'menu_details': menuDetails
        }

        const apiParams = { "doctype": "Store Menu" };
        storeEntryId && (apiParams["name"] = storeEntryId)

        setIsFormSubmitting(true);
        let apiUrl = `${baseUrl}/.netlify/functions/erp_api`;
        let apiPromise = null;
        if (storeEntryId) {
            apiPromise = apiHelper.put({ "url": apiUrl, "params": apiParams, "data": payload })
        } else {
            apiPromise = apiHelper.post({ "url": apiUrl, "params": apiParams, "data": payload })
        }
        apiPromise
        .then(response => {
            if (response.status) {
                fillData();
                setIsFormSubmitting(false);
                notify.success({ "description": "Entry successfully added !" })
            } else { console.log(response.json); setIsFormSubmitting(false);
                notify.error({ "description": JSON.stringify(response.json) })
            }
        })
    }

    const loadMenuTypeOptions = function() {
        const apiParams = {
            "doctype": "Store Menu Type",
            "fields": JSON.stringify(["menu_type"]),
            "order_by": "menu_type asc",
            "limit": 1000,
        }
        apiHelper.get({ "url": `${baseUrl}/.netlify/functions/erp_api`,
            "params": apiParams })
        .then(response => {
            if (response.status) {
                setMenuTypeOptions(response.json.data.map(el => el.menu_type));
            } else { console.log(response.json); }
        })
    }

    const loadStoreEntryDetail = function(storeEntryId) {
        const apiParams = {
            "doctype": "Store Entry",
            "name": storeEntryId,
            "fields": JSON.stringify(["*"]),
            "limit": "100"
        }
        apiHelper.get({ "url": `${baseUrl}/.netlify/functions/erp_api`,
            "params": apiParams })
        .then(response => {
            if (response.status) {
                fillData(response.json.data);
            } else {
                console.log(response.json);
            }
        })
    }

    const fillData = function(data) {
        setStoreEntryId(data ? data.name : null);

        setmenuDate(data ? data.entry_datetime : DateTime.now());
        setStoreProduct(data ? data.product : null);
        setMenuType(data ? data.menu_type : null);
        setMenuDetails(data ? data.menu_details : '');
    }

    const checkForFormErrors = function(field, isError) {
        console.log(field, isError)
        formErrorState.current[field] = isError
        return isError;
    }

    useEffect(function() {
        loadMenuTypeOptions();
        if (searchParams.get('store_entry_id')) {
            loadStoreEntryDetail(searchParams.get('store_entry_id'));
        }
    }, []);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center',
            padding: '15px' }}>
            <ColumnBox sx={{ alignItems: 'center', maxWidth: '500px',
                width: '100%' }}>
                <SmallHeading>{entryType}</SmallHeading>
                <Box sx={{ marginTop: '15px', width: '100%' }}>
                    <LocalizationProvider dateAdapter={AdapterLuxon}>
                        <MobileDatePicker
                            onChange={(newValue) => { setmenuDate(newValue); }}
                            value={menuDate}
                            inputFormat="dd-MMM-yyyy"
                            closeOnSelect={true} disableMaskedInput={true}
                            renderInput={(params) => <TextField {...params} required
                                error={checkForFormErrors('menuDate', !menuDate)}
                                label="Entry Date" size="small" sx={{ width: '100%' }} />}
                        />
                    </LocalizationProvider>
                </Box>
                <Autocomplete
                    disablePortal
                    size="small"
                    onChange={(e, newValue) => { setMenuType(newValue); }}
                    options={menuTypeOptions}
                    value={menuType}
                    sx={{ width: '100%', marginTop: '15px' }}
                    renderInput={(params) => <TextField required
                        error={checkForFormErrors('menuType', !menuType)}
                        {...params} label="Menu Type" />}
                />
                <TextField label="Menu details"
                    sx={{ width: '100%', marginTop: '15px' }}
                    minRows={2} required
                    error={checkForFormErrors('menuDetails', !menuDetails)}
                    onChange={(e) => { setMenuDetails(e.target.value); }}
                    value={menuDetails}
                    multiline={true} />

                { isFormSubmitting ? <CircularProgress sx={{ marginTop: '15px' }} /> :
                    <Button sx={{ marginTop: '15px' }} onClick={() => onClickSave()}
                        variant="outlined">Save</Button>
                }
            </ColumnBox>
        </Box>
    );
}
